


























































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Watch } from 'vue-property-decorator';
import { GridIcon, XIcon } from 'vue-feather-icons';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import ProductFilterComponent from '@/components/filters/ProductFilter.vue';
import TagFilterComponent from '@/components/filters/TagFilter.vue';
import { FilterMixin } from '@/mixins/FilterMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { DamageFilter, DateFilter, IUser, IProduct, ITag } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';

@Component({
  components: {
    'user-filter': UserFilterComponent,
    'product-filter': ProductFilterComponent,
    'tag-filter': TagFilterComponent,
    XIcon,
    GridIcon,
  },
})
export default class DamageFilterComponent extends mixins(FilterMixin, PermissionMixin) {
  filter: DamageFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
    tags: [],
  };

  get isDefaultFilter() {
    return (
      this.filter.dateFilter === DateFilter.ALL &&
      this.filter.users?.length === 0 &&
      this.filter.products?.length === 0 &&
      this.filter.tags?.length === 0
    );
  }

  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }
    await this.$store.dispatch(
      `PreferencesModule/${PreferencesAction.setDamageFilter}`,
      this.filter,
    );
    this.$root.$emit('change-damage-filter');
    this.close();
  }

  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }

  updateProductFilter(products: IProduct[]) {
    this.filter.products = [...products];
    this.updateFilter();
  }

  updateTagsFilter(tags: ITag[]) {
    this.filter.tags = [...tags];
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      dateFilter: DateFilter.ALL,
      products: [],
      users: [],
      tags: [],
    };
    this.filter.users = [];
    this.filter.dateFilter = DateFilter.ALL;
    this.updateFilter();
    this.$root.$emit('reset-damage-filter');
  }

  get damageFilter() {
    return this.$store.getters['PreferencesModule/getDamageFilter'];
  }

  @Watch('damageFilter')
  async onDamageFilterChanged(damageFilter: DamageFilter) {
    this.filter = damageFilter;
  }

  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getDamageFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Filter ist etwas schiefgelaufen.');
    }
    this.$root.$on('update-damage-filter', async () => {
      await this.updateFilter();
    });
  }

  selectedFilterString() {
    let str = '';
    if (this.filter.products && this.filter.products.length > 0) {
      str += this.filter.products[0].name + ', ';
    }
    if (this.filter.users && this.filter.users.length > 0) {
      str += this.filter.users[0].firstname + ', ';
    }
    if (this.filter.tags && this.filter.tags.length > 0) {
      str += '#' + this.filter.tags[0].name + ', ';
    }
    return str.substr(0, str.length - 2);
  }
}
